// Keyboard shortcuts cheat sheet modal. Extracted from DataSurfaceV3
// during the agent-velocity refactor — fully self-contained, only
// needs `open` + `onClose` from the parent so the parent file stays
// small. Toggled by `?` keypress or the toolbar `?` button; closes
// on backdrop click, Esc handling stays in the parent (it also
// drives the same `setShowShortcuts(false)` path).

import * as React from 'react';

const ROWS: Array<[string, string]> = [
  ['r',                  'Refresh the current view'],
  ['?',                  'Show / hide this cheat sheet'],
  ['Esc',                'Clear selection · close popover · close lineage drawer'],
  ['click cell',         'Filter where column = value'],
  ['click event_id',     'Open lineage drawer'],
  ['click header',       'Sort column (cycles ASC → DESC → none)'],
  ['right-click header', 'Sort / hide / filter on that column'],
  ['hover cell',         'Preview pretty-printed value (when truncated)'],
];

export function ShortcutsCheatSheet({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}): React.ReactElement | null {
  if (!open) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0,
        background: 'oklch(0.18 0.01 250 / 0.4)',
        zIndex: 1500,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: 'var(--bg-elev)', border: '1px solid var(--line)', borderRadius: 8,
          padding: '20px 24px', minWidth: 320, maxWidth: 480,
          boxShadow: '0 10px 40px oklch(0.18 0.01 250 / 0.30)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 12 }}>
          <strong style={{ fontSize: 14 }}>Keyboard shortcuts</strong>
          <button
            type="button"
            onClick={onClose}
            style={{ background: 'transparent', border: 'none', color: 'var(--ink-3)', cursor: 'pointer', fontSize: 14, padding: 0 }}
            aria-label="Close"
          >×</button>
        </div>
        <table style={{ width: '100%', fontSize: 12.5, borderCollapse: 'collapse' }}>
          <tbody>
            {ROWS.map(([k, desc]) => (
              <tr key={k}>
                <td style={{ padding: '4px 0', width: 120 }}>
                  <code style={{
                    fontFamily: 'var(--mono)', fontSize: 11,
                    padding: '2px 8px',
                    background: 'var(--bg-sunken)', border: '1px solid var(--line)',
                    borderRadius: 3,
                  }}>{k}</code>
                </td>
                <td style={{ padding: '4px 0', color: 'var(--ink-2)' }}>{desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ marginTop: 12, fontSize: 11, color: 'var(--ink-3)' }}>
          Shortcuts are inactive while typing in an input.
        </div>
      </div>
    </div>
  );
}
